import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";

export default function AlertComponent({
  open,
  handleSuccess,
  handleClose,
  message,
  cancelBtnConfig,
  successBtnConfig,
}) {
  let { hide: hideCancel, label: cancelLabel } = cancelBtnConfig || {};
  let {
    hide: hideSuccess,
    disable,
    label: successLabel,
  } = successBtnConfig || {};
  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText
            id="alert-dialog-description"
            component="pre"
            sx={{
              whiteSpace: "pre-wrap", // wraps lines within <pre>
              wordBreak: "break-word", // breaks long words
              overflowX: "hidden", // optional: hide horizontal scroll
            }}
          >
            {message}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {!hideCancel && (
            <Button onClick={handleClose} autoFocus>
              {cancelLabel || "Cancel"}
            </Button>
          )}
          {!hideSuccess && (
            <Button onClick={handleSuccess} autoFocus>
              Yes
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </div>
  );
}
